import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  isLoading = new Subject<boolean>();

  /**
   * Defer show to the next macrotask so AppComponent's `isLoading | async` does not update
   * in the same change-detection pass (avoids NG0100 ExpressionChangedAfterItHasBeenCheckedError
   * when HTTP runs from ngOnInit / route init).
   */
  showLottieLoader() {
    setTimeout(() => this.isLoading.next(true), 0);
  }

  hideLottieLoader() {
    setTimeout(() => this.isLoading.next(false), 0);
  }
}
